import React from 'react';
import { Card } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { DETALLES_INFO } from '../utils/commons'
import { useState } from "react";

 const CarouselSlideSector = (props) => {
    const  body  = props.body;
    const [index, setIndex] = useState(0);
    const numSlides = DETALLES_INFO.length;
    const { id, title } = DETALLES_INFO[index];

    const Arrow = (props) => {
      const { direction, clickFunction } = props;
      const icon = direction === 'left' ? <ArrowBackIosNewIcon/> : <ArrowForwardIosIcon/>;

      if(direction === 'left'){
        return <div className="carousel-arrow-left" onClick={clickFunction}>{icon}</div>;
      }else{
        return <div className="carousel-arrow-rigth" onClick={clickFunction}>{icon}</div>;
      }  
  }

  const onArrowClick = (direction) => {
      const increment = direction === 'left' ? -1 : 1;
      const newIndex = (index + increment + numSlides) % numSlides;
      setIndex(newIndex);
  };

    let bodyContent;
  switch (id) {
    case 1:
      bodyContent = (
        <div className="carousel-properties" >
          <p>Marco de plantación (entre árbol): <span>{body.distanciaArboles % 1 === 0 ? body.distanciaArboles : body.distanciaArboles.toFixed(2)}</span></p>
          <p>Marco de plantación (entre líneas):  <span>{body.distanciaLineas % 1 === 0 ? body.distanciaLineas : body.distanciaLineas.toFixed(2)}</span></p>
          <p>Diámetro de copa: <span>{body.diametroCopa % 1 === 0 ? body.diametroCopa : body.diametroCopa.toFixed(2)}</span></p>
          <p>Seto: <span>{body.seto === 1 ? "Sí" : "No"}</span></p>
        </div>
      );
      break;
    case 2:
      if(body.texturaSuelo !== ""){
        bodyContent = (
            <div className="carousel-properties" >
              <p>Textura del Suelo: <span>{body.texturaSuelo}</span></p>
            </div>
        );
      }else{
        bodyContent = (
          <div className="carousel-properties" >
            <p>Porcentaje de Arcilla: <span>{body.ptArcilla}</span></p>
            <p>Porcentaje de Limo: <span>{body.ptLimo}</span></p>
            <p>Porcentaje de Arena: <span>{body.ptArena}</span></p>
          </div>
        );
      }
      
      break;
      case 3:
      bodyContent = (
        <div className="carousel-properties" >
          <p>Sistema de riego por goteo: <span>{body.nombre}</span></p>
          <p>Nº de ramales por líneas de cultivo:  <span>{body.nGoteros % 1 === 0 ? body.nGoteros : body.nGoteros.toFixed(2)}</span></p>
          <p>Distancia entre goteros: <span>{body.distanciaGoteros % 1 === 0 ? body.distanciaGoteros : body.distanciaGoteros.toFixed(2)}</span></p>
          <p>Caudal nominal del gotero: <span>{body.caudalGotero % 1 === 0 ? body.caudalGotero: body.caudalGotero.toFixed(2)}</span></p>
          <p>Superficie del sector: <span>{body.superficieSector % 1 === 0 ? body.superficieSector : body.superficieSector.toFixed(2)}</span></p>
        </div>
      );
      break;
      case 4:
      bodyContent = (
        <div className="carousel-properties" >
          <p>Estrategia: <span>{body.estrategia}</span></p>
        </div>
      );
      break;
      case 5:
      bodyContent = (
        <div className="carousel-properties" >
          <p>Horas máximas de riego (L-V): <span>{body.limiteLV}</span></p>
          <p>Horas máximas de riego (S-D):  <span>{body.limiteSD}</span></p>
        </div>
      );
      break;
      case 6:
      bodyContent = (
        <div className="carousel-properties" >
          <p>Dotación máxima de agua de riego: <span>{body.dotacionRiego % 1 === 0 ? body.dotacionRiego: body.dotacionRiego.toFixed(2)}</span></p>
          <p>Conductividad eléctrica del agua de riego: <span>{body.conductividad % 1 === 0 ? body.conductividad : body.conductividad.toFixed(2)}</span></p>
        </div>
      );
      break;
      case 7:
      bodyContent = (
        <div className="carousel-properties" >
          <p>Cálculo P.E.: <span>{body.metodoCalculoPE}</span></p>
        </div>
      );
      break;
      case 8:
      bodyContent = (
        <div className="carousel-properties" >
          <p>Riego Aplicado: <span>{body.hRiegoAPlicadas % 1 === 0 ? body.hRiegoAPlicadas : body.hRiegoAPlicadas.toFixed(2)}</span></p>
        </div>
      );
      break;
    default:
      bodyContent = null;
  }

    return (
      <>
      <div style={{display: "flex", flexDirection:"column", alignItems:"center", position: "relative", width:"100%"}}>
        <h2>{title}</h2>
          <Card className="carousel-card">
              <Arrow
                direction='left'
                clickFunction={() => onArrowClick('left')}
              />
              {bodyContent}
              <Arrow
                direction='right'
                clickFunction={() => onArrowClick('right')}
              />
          </Card>
      </div>
      </>
    );
}
export default CarouselSlideSector;